// Repères du parcours d'inscription, pour PostHog.
//
// Le constat du 22 sept 2026 : 43 personnes ouvrent l'inscription, 10 la
// terminent. On savait QU'ils abandonnent, jamais OÙ. Ces repères répondent à
// la question sur tout le monde ; le replay, qui filme toutes les sessions,
// permet d'aller voir un cas.
//
// Les événements sont gratuits : 95 000 consommés sur 1 000 000 inclus.
//
// Aucune donnée personnelle ici : jamais le courriel, jamais le mot de passe,
// jamais le numéro. Seulement l'étape et ce qui a bloqué.

import posthog from 'posthog-js'

/** Les étapes du parcours, dans l'ordre où on les traverse. */
export type EtapeInscription =
  | 'formulaire_ouvert'
  | 'courriel_saisi'
  | 'mot_de_passe_saisi'
  | 'turnstile_vu'
  | 'formulaire_envoye'
  | 'compte_cree'
  | 'courriel_verifie'
  | 'onboarding_etape1'
  | 'onboarding_etape2'
  | 'onboarding_etape3'
  | 'onboarding_termine'

/** Marque une étape franchie. Ne jette jamais : la mesure ne casse pas l'inscription. */
export function etape(nom: EtapeInscription, extra: Record<string, unknown> = {}): void {
  try {
    posthog.capture('inscription_etape', { etape: nom, ...extra })
  } catch {
    // PostHog absent (dev local, bloqueur de pub) : on continue sans bruit.
  }
}

/** Ce qui se passe dans le formulaire de carte. Le replay ne le montre jamais : la
 *  zone de carte est une page de Stripe, que PostHog n'enregistre pas. Sans ces
 *  repères, une zone restée vide ne se distingue pas d'une carte bien saisie
 *  (relevé du 25 oct 2026 : trois sessions « sans formulaire », dont une où Stripe
 *  avait bien reçu la carte). */
export type EtapePaiement =
  | 'formulaire_pret'
  | 'formulaire_erreur'
  | 'formulaire_lent'
  | 'envoye'
  | 'refuse'
  | 'envoi_long'
  | 'accepte'

/** Une page traduite par le navigateur : Google Translate change la langue de
 *  <html> et pose une classe ; nous n'y mettons que fr ou en. */
function pageTraduite(): boolean {
  const html = document.documentElement
  return html.classList.contains('translated-ltr') || html.classList.contains('translated-rtl')
    || !['fr', 'en'].includes(html.lang)
}

/** Marque une étape du paiement. Ne jette jamais. Jamais la carte, seulement l'étape et un code. */
export function paiement(nom: EtapePaiement, extra: Record<string, unknown> = {}): void {
  try {
    posthog.capture('paiement_carte', { etape: nom, traduit: pageTraduite(), ...extra })
  } catch {
    /* rien */
  }
}

/** Marque un blocage : c'est ce qui explique les abandons.
 *  `motif` est un code court et stable (`courriel_deja_pris`, `mot_de_passe_faible`,
 *  `turnstile_echec`…), jamais le message affiché, qui change avec la langue. */
export function blocage(etapeNom: EtapeInscription, motif: string): void {
  try {
    posthog.capture('inscription_blocage', { etape: etapeNom, motif: String(motif).slice(0, 64) })
  } catch {
    /* rien */
  }
}
